export { OutOfOfficeOptionsItem as default };

/**
* Out Of Office Options Item Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class OutOfOfficeOptionsItem {
  /**
   * Defines if out of office is enabled
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  enabled;

  /**
   * Defines Start Date
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  date_start;

  /**
   * Defines End Date
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
   date_end;

  /**
   * Out of Office Message
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  message;
}